import { memo } from 'react';
import { NODE_WIDTH, NODE_HEIGHT } from '../const';
import { NodeComponent } from './components/SweepNodeComponent';
import { RfDropZoneNode } from '../canvas-types/nodeTypesData';
import { NodeProps } from '@xyflow/react';
import { getObjectTypeColor } from '../helpers/getObjectTypeColor';

const DropZoneNode = ({ data }: NodeProps<RfDropZoneNode>) => {
  if (data.type === 'regular') {
    return (
      <NodeComponent
        sx={{
          width: `${NODE_WIDTH}px`,
          height: `${NODE_HEIGHT}px`,
          border: '2px solid transparent',
          cursor: 'default',
          background: 'black',
          opacity: 0.04,
        }}
      />
    );
  } else if (data.type === 'reorderSteps') {
    return (
      <NodeComponent
        sx={{
          width: `${NODE_WIDTH}px`,
          height: `${NODE_HEIGHT}px`,
          border: `2px solid ${getObjectTypeColor(data.objectType).connection}`,
          cursor: 'default',
          background: 'transparent',
        }}
      />
    );
  }

  return <></>;
};

const _memoDropZoneNode = memo(DropZoneNode);

export { _memoDropZoneNode as DropZoneNode };
